var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"u-notice"},[_c('page-nav',{attrs:{"nav-list":_vm.navList}}),_c('div',{staticClass:"content"},[_c('news-list',{attrs:{"prop-list":_vm.listData,"list-number":_vm.listNumber}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }